module.exports = __webpack_public_path__ + "static/img/s2topbg.2724a7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nbaip/s2topbg.png
// module id = 5X8H
// module chunks = 0